export enum FrequencyTypeEnum {
    Monthly = "Monthly",
    Yearly = "Yearly"
}